module.exports = __webpack_public_path__ + "321bd702adc4c51d1127b01c8832da78.svg";